import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MaestroModel } from '../maestro.model';
import { EmpresaService } from 'src/app/services/administracion/empresa.service';
import { IResponse } from 'src/app/pages/base/interfaces';

export class Empresa extends MaestroModel {
    public static RECORD_NAME = 'empresas';
    public static CODIGO_REGISTRO = 'empresa';
    public static CODIGO_MODULO = 'administracion';
    public static NOMBRE_SINGULAR = 'Empresa';
    public static NOMBRE_PLURAL = 'Empresas';

    public static TIPO_GLOBAL = 1;
    public static TIPO_SUCURSAL = 2;

    public static CONTROL_CREDITO_PREPAGO = 1;
    public static CONTROL_CREDITO_POSPAGO = 2;

    public static ENABLE_FIELDS: string[] = ['hora_bloqueo'];
    public static DISABLE_FIELDS: string[] = ['hora_bloqueo'];

    public static TIPOS = [
        { valor: 1, nombre: 'GLOBAL' },
        { valor: 2, nombre: 'SUCURSAL' },
    ];

    public static PERIODOS_GRACIA = [
        { valor: 1, nombre: '24 horas' },
        { valor: 2, nombre: '48 horas' },
        { valor: 3, nombre: '72 horas' },
    ];

    public static CONTROL_CREDITO = [
        { valor: 1, nombre: 'PREPAGO' },
        { valor: 2, nombre: 'POSPAGO' },
    ];

    private _idAdmin: number;
    private _nombreAdmin: string;
    private _nombreFantasia: string;
    private _nroDocumento: string;
    private _ciudad: string;
    private _barrio: string;
    private _direccion: string;
    private _telefono: string;
    private _celular: string;
    private _correo: string;
    private _ubicacion: string;
    private _personaContacto: string;
    private _controlCredito: number;
    private _limiteCredito: number;
    private _consumoCredito: number;
    private _comentario: string;
    private _referencia: string;
    private _tipo: number;
    private _periodoGracia: number;
    private _horaBloqueo: Date | string;
    private _idVendedor: number;
    private _nombreVendedor: string;
    private _autogestion: boolean;
    private _bloqueado: boolean;
    private _creditoDistribuido: number;

    constructor() {
        super();
        this._controlCredito = 2;
        this._limiteCredito = 0;
        this._consumoCredito = 0;
        this._tipo = Empresa.TIPO_GLOBAL;
        this._periodoGracia = 1;
        this._horaBloqueo = '14:00';
        this._autogestion = false;
        this._bloqueado = false;
        this._creditoDistribuido = 0;
        this.asignarEmpresa();
    }

    // cargarmos el idAdmin si la empresa del usuario es autogestionado
    private asignarEmpresa() {
        const cu = this.seguridad.getCurrentUser();
        if (cu.empresa.autogestion) {
            this._idAdmin = cu.empresa.id;
            this._nombreAdmin = cu.empresa.nombre;
        }
    }

    public set idAdmin(idAdmin: number) {
        this._idAdmin = idAdmin;
    }
    public get idAdmin(): number {
        return this._idAdmin;
    }

    public set nombreAdmin(nombreAdmin: string) {
        this._nombreAdmin = nombreAdmin;
    }
    public get nombreAdmin(): string {
        return this._nombreAdmin;
    }

    public set nombreFantasia(nombreFantasia: string) {
        this._nombreFantasia = nombreFantasia;
    }
    public get nombreFantansia(): string {
        return this._nombreFantasia;
    }

    public set nroDocumento(nroDocumento: string) {
        this._nroDocumento = nroDocumento;
    }
    public get nroDocumento(): string {
        return this._nroDocumento;
    }

    public set ciudad(ciudad: string) {
        this._ciudad = ciudad;
    }
    public get ciudad(): string {
        return this._ciudad;
    }

    public set barrio(barrio: string) {
        this._barrio = barrio;
    }
    public get barrio(): string {
        return this._barrio;
    }

    public set direccion(direccion: string) {
        this._ciudad = direccion;
    }
    public get direccion(): string {
        return this._direccion;
    }

    public set telefono(telefono: string) {
        this._ciudad = telefono;
    }
    public get telefono(): string {
        return this._telefono;
    }

    public set celular(celular: string) {
        this._celular = celular;
    }
    public get celular(): string {
        return this._celular;
    }

    public set correo(correo: string) {
        this._correo = correo;
    }
    public get correo(): string {
        return this._correo;
    }

    public set ubicacion(ubicacion: string) {
        this._ubicacion = ubicacion;
    }
    public get ubicacion(): string {
        return this._ubicacion;
    }

    public set personaContacto(personaContacto: string) {
        this._personaContacto = personaContacto;
    }
    public get personaContacto(): string {
        return this._personaContacto;
    }

    public set controlCredito(controlCredito: number) {
        this._controlCredito = controlCredito;
    }
    public get controlCredito(): number {
        return this._controlCredito;
    }

    public set limiteCredito(limiteCredito: number) {
        this._limiteCredito = limiteCredito;
    }
    public get limiteCredito(): number {
        return this._limiteCredito;
    }

    public set consumoCredito(consumoCredito: number) {
        this._consumoCredito = consumoCredito;
    }
    public get consumoCredito(): number {
        return this._consumoCredito;
    }

    public set comentario(comentario: string) {
        this._comentario = comentario;
    }
    public get comentario(): string {
        return this._comentario;
    }

    public set referencia(referencia: string) {
        this._referencia = referencia;
    }
    public get referencia(): string {
        return this._referencia;
    }

    public set bloqueado(bloqueado: boolean) {
        this._bloqueado = bloqueado;
    }
    public get bloqueado(): boolean {
        return this._bloqueado;
    }

    public set autogestion(autogestion: boolean) {
        this._autogestion = autogestion;
    }
    public get autogestion(): boolean {
        return this._autogestion;
    }

    public set tipo(tipo: number) {
        this._tipo = tipo;
    }
    public get tipo(): number {
        return this._tipo;
    }

    public set periodoGracia(periodoGracia: number) {
        this._periodoGracia = periodoGracia;
    }
    public get periodoGracia(): number {
        return this._periodoGracia;
    }

    public set horaBloqueo(horaBloqueo: Date | string) {
        this._horaBloqueo = horaBloqueo;
    }
    public get horaBloqueo(): Date | string {
        return this._horaBloqueo;
    }

    public set idVendedor(idVendedor: number) {
        this._idVendedor = idVendedor;
    }
    public get idVendedor(): number {
        return this._idVendedor;
    }

    public set nombreVendedor(nombreVendedor: string) {
        this._nombreVendedor = nombreVendedor;
    }
    public get nombreVendedor(): string {
        return this._nombreVendedor;
    }

    public set creditoDistribuido(creditoDistribuido: number) {
        this._creditoDistribuido = creditoDistribuido;
    }
    public get creditoDistribuido(): number {
        return this._creditoDistribuido;
    }

    public static get columsOnLista(): Record<string, any>[] {
        return [
            { field: 'id', label: 'ID', type: 'id' },
            { field: 'nro_documento', label: 'Documento', type: 'text' },
            { field: 'nombre', label: 'Nombre', type: 'text' },
            // { field: 'nombre_fantasia', label: 'Nombre Fantasia', type: 'text' },
            { field: 'ciudad', label: 'Ciudad', type: 'text' },
            { field: 'direccion', label: 'Direccion', type: 'text' },
            // { field: 'telefono', label: 'Telefono', type: 'text' },
            // { field: 'bloqueado', label: 'Bloqueado', type: 'boolean' },
        ];
    }

    private async cargarDatos(objeto: Record<string, any>) {
        this.id = objeto.id;
        this._idAdmin = objeto.id_admin;
        this._nombreAdmin = objeto.admin?.nombre;
        this._autogestion = objeto.autogestion;
        this._nombreFantasia = objeto.nombre_fantasia;
        this._nroDocumento = objeto.nro_documento;
        this._ciudad = objeto.ciudad;
        this._barrio = objeto.barrio;
        this._direccion = objeto.direccion;
        this._telefono = objeto.telefono;
        this._celular = objeto.celular;
        this._correo = objeto.correo;
        this._ubicacion = objeto.ubicacion;
        this._personaContacto = objeto.persona_contacto;
        this._controlCredito = objeto.control_credito;
        this._limiteCredito = objeto.limite_credito;
        this._consumoCredito = objeto.consumo_credito;
        this._comentario = objeto.comentario;
        this._referencia = objeto.referencia;
        this._tipo = objeto.tipo;
        this._periodoGracia = objeto.periodo_gracia;
        this._idVendedor = objeto.id_vendedor;
        this._nombreVendedor = objeto.vendedor?.nombre;
        this._bloqueado = objeto.bloqueado;
        this._creditoDistribuido = objeto.credito_distribuido;
    }

    override async cargarObjeto(objeto: Record<string, any>) {
        await super.cargarObjeto(objeto);
        await this.cargarDatos(objeto);
        this._horaBloqueo = this.stringADate(objeto?.hora_bloqueo);
    }

    override async actualizarDatos(objeto: Record<string, any>) {
        await super.actualizarDatos(objeto);
        await this.cargarDatos(objeto);
        this._horaBloqueo = this.dateToString(objeto.hora_bloqueo);
    }

    /**
     * Retorna el formulario a utilizar en las ventanas
     * @returns FormGroup
     */
    override async getFormGroup(): Promise<FormGroup> {
        let fg = await super.getFormGroup();
        fg.addControl('id', new FormControl(this.id));
        fg.addControl('id_admin', new FormControl(this._idAdmin));
        fg.addControl('nombre_admin', new FormControl(this._nombreAdmin));
        fg.addControl(
            'nombre_fantasia',
            new FormControl(this._nombreFantasia, Validators.required)
        );
        fg.addControl(
            'nro_documento',
            new FormControl(this._nroDocumento, Validators.required)
        );
        fg.addControl('ciudad', new FormControl(this._ciudad));
        fg.addControl('barrio', new FormControl(this._barrio));
        fg.addControl('direccion', new FormControl(this._direccion));
        fg.addControl('telefono', new FormControl(this._telefono));
        fg.addControl('celular', new FormControl(this._celular));
        fg.addControl('correo', new FormControl(this._correo));
        fg.addControl('ubicacion', new FormControl(this._ubicacion));
        fg.addControl(
            'persona_contacto',
            new FormControl(this._personaContacto)
        );
        fg.addControl('control_credito', new FormControl(this._controlCredito));
        fg.addControl(
            'limite_credito',
            new FormControl(this._limiteCredito, Validators.required)
        );
        fg.addControl(
            'consumo_credito',
            new FormControl(this._consumoCredito, Validators.required)
        );
        fg.addControl('comentario', new FormControl(this._comentario));
        fg.addControl('referencia', new FormControl(this._referencia));
        fg.addControl('tipo', new FormControl(this._tipo));
        fg.addControl('periodo_gracia', new FormControl(this._periodoGracia));
        fg.addControl('hora_bloqueo', new FormControl(this._horaBloqueo));
        fg.addControl('id_vendedor', new FormControl(this._idVendedor));
        fg.addControl('nombre_vendedor', new FormControl(this._nombreVendedor));
        fg.addControl('autogestion', new FormControl(this._autogestion));
        fg.addControl('bloqueado', new FormControl(this._bloqueado));
        fg.addControl(
            'credito_distribuido',
            new FormControl(this._creditoDistribuido)
        );
        return fg;
    }

    stringADate(timeString: string): Date {
        const date = new Date();

        const [hours, minutes, seconds] = timeString.split(':').map(Number);

        date.setHours(hours, minutes, seconds, 0);

        return date;
    }

    dateToString(fecha: Date | string): string {
        if (fecha instanceof Date) {
            return `${fecha.getHours()}:${fecha.getMinutes()}:${fecha.getSeconds()}`;
        }
        return `${fecha}:00`;
    }

    override async guardar(service: EmpresaService): Promise<IResponse> {
        return await service.post(this.serverJson);
    }

    override async actualizar(service: EmpresaService): Promise<IResponse> {
        return await service.put(this.id, this.serverJson);
    }

    override async eliminar(service: EmpresaService): Promise<IResponse> {
        return await service.delete(this.id);
    }
}
